module.exports = __webpack_public_path__ + "media/high-tier-poster.1d1b6627.mp4";